/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { ApplicationCheck } from "./ApplicationCheck";

export const ApplicationColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { absenteeismValues, setAbsenteeismValues }
) => (
  <ApplicationCheck
    id={row.id}
    parentId={row.parentId}
    studentName={row.studentName}
    absenteeismValues={absenteeismValues}
    setAbsenteeismValues={setAbsenteeismValues}
  />
)